import React, { useState } from "react";
import { calculateTotal, makeAxiosCall, tierCalc } from "../utils.js";
import axios from "axios";

export const UserContext = React.createContext();

const LOGIN_URL = "https://www.blizzardpro.com/account?redirect=https://www.blizzardpro.com/";

const redirectToLogin = () => {
  localStorage.removeItem("auth_token");
  window.location.href = LOGIN_URL;
};

const UserProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [tokenExpired, setTokenExpired] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState();
  const [loading, setLoading] = useState(true);

  const fetchUser = () => {
    setLoading(true);
    makeAxiosCall("get", "/bear")
    .then(()=> {
      makeAxiosCall("get", `/customer-info`)
      .then((res) => {
        setLoading(false);
        const customerOrderTotal = calculateTotal(res.data.orders);
        const tier = tierCalc(res.data.orders);
        setUser({ ...res.data, customerOrderTotal, tier });
        setIsLoggedIn(true);
      })
      .catch((err) => {
        console.log(err);
        redirectToLogin();
      });
    })
    .catch((err) => {
      console.log(err);
      redirectToLogin();
    });
  };

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");
    const storedToken = localStorage.getItem("auth_token");
    const t = urlToken || storedToken;

    if (urlToken) {
      localStorage.setItem("auth_token", urlToken);
      urlParams.delete("token");
      const newSearch = urlParams.toString();
      window.history.replaceState({}, "", newSearch ? `?${newSearch}` : window.location.pathname);
    }

    if (t) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${t}`;
      makeAxiosCall("get", `/bear`)
        .then(() => {
          fetchUser();
        })
        .catch((err) => {
          console.log(err);
          redirectToLogin();
        });
    } else {
      redirectToLogin();
    }
  }, []);

  const updateAddress = (address) => {
    makeAxiosCall("put", `/address`, address).then((res) => {
      console.log(res);
      setUser({ ...user, addresses: res.data });
    });
  };

  const signOut = () => {
    makeAxiosCall("get", `/logout`).then((res) => {
      console.log(res);
      localStorage.removeItem("auth_token");
      setUser();
      setIsLoggedIn(false);
      window.location.href = "https://www.blizzardpro.com";
    });
  };

  return (
    <UserContext.Provider
      value={{
        user,
        signOut,
        setUser,
        tokenExpired,
        loading,
        updateAddress,
        setTokenExpired,
        isLoggedIn,
        setIsLoggedIn,
        token,
        setToken,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
